import React from 'react';
import { IconProps } from '../types';

export const Wheelbarrow: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" fill="white" />
    <path
      d="M24.1227 10.5039L21.6945 14.6665C21.5693 14.8811 21.3688 15.0414 21.1319 15.1163L12.5158 17.8371C12.1939 17.9388 11.8426 17.8712 11.5814 17.6575L3.16817 10.774C2.44082 10.1789 2.86162 9 3.80141 9H23.259C24.0308 9 24.5116 9.83721 24.1227 10.5039Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31 7H28.5L23 17L10 21"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 17V22.2325C23 23.761 21.761 25 20.2325 25V25C19.448 25 18.7003 24.667 18.1755 24.0839L14.5 20"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6"
      cy="22"
      r="4"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6"
      cy="22"
      r="1"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
